import { render, staticRenderFns } from "./UploadLogoButton.vue?vue&type=template&id=123c05ef&scoped=true&"
import script from "./UploadLogoButton.vue?vue&type=script&lang=js&"
export * from "./UploadLogoButton.vue?vue&type=script&lang=js&"
import style0 from "./UploadLogoButton.vue?vue&type=style&index=0&id=123c05ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c05ef",
  null
  
)

export default component.exports